import { render, staticRenderFns } from "./SpaceDetails.vue?vue&type=template&id=414f936e&scoped=true&"
import script from "./SpaceDetails.vue?vue&type=script&lang=js&"
export * from "./SpaceDetails.vue?vue&type=script&lang=js&"
import style0 from "./SpaceDetails.vue?vue&type=style&index=0&id=414f936e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414f936e",
  null
  
)

export default component.exports